import type { MRT_ColumnDef } from "@ngt/mantine-react-table";
import DataGridTruncateCell from "./DataGridTruncateCell";
import dayjs from "dayjs";
import "dayjs/plugin/relativeTime";
import { useMemo } from "react";
import { DataList } from "@mantine/core";

const DataGridDateCell: MRT_ColumnDef<any>["Cell"] = ({ cell }) => {
    const value = cell.getValue<string>();

    const values = useMemo(() => {
        if (!value) {
            return undefined;
        }

        const date = dayjs(value);
        const now = dayjs();

        return {
            date: date.format("DD/MM/YYYY"),
            relative: now.isAfter(date) ? date.fromNow() : date.toNow(),
        };
    }, [value]);

    if (!values) {
        return null;
    }

    return (
        <DataGridTruncateCell
            tooltip={
                <DataList>
                    <DataList.Item>
                        <DataList.ItemLabel>Date</DataList.ItemLabel>
                        <DataList.ItemValue>{values.date}</DataList.ItemValue>
                    </DataList.Item>
                    <DataList.Item>
                        <DataList.ItemLabel>Relative</DataList.ItemLabel>
                        <DataList.ItemValue>{values.relative}</DataList.ItemValue>
                    </DataList.Item>
                </DataList>
            }
            value={values.date}
        />
    );
};
export default DataGridDateCell;
